export const capitalizeFirstLetter = (s: string) => `${s.charAt(0).toUpperCase()}${s.slice(1)}`;

export const roundValue = (value, decimals) => Number(
  `${Math.round(`${value}e${decimals}`)}e-${decimals}`,
) || null;
